import { render } from "./Home.vue?vue&type=template&id=65295774&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=65295774&lang=scss&scoped=true"

import exportComponent from "D:\\SI1280\\project\\Vue-portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65295774"]])

export default __exports__